import type { SVGProps } from "react";

type P = SVGProps<SVGSVGElement>;

const base: P = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 24 24",
};

export const Icon = {
  Grid: (p: P) => (
    <svg {...base} {...p}>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  Map: (p: P) => (
    <svg {...base} {...p}>
      <path d="M9 4l-6 2v14l6-2 6 2 6-2V4l-6 2-6-2z" />
      <path d="M9 4v14" />
      <path d="M15 6v14" />
    </svg>
  ),
  Radio: (p: P) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="1.5" />
      <path d="M8.5 8.5a5 5 0 0 0 0 7" />
      <path d="M15.5 15.5a5 5 0 0 0 0-7" />
      <path d="M5.5 5.5a9 9 0 0 0 0 13" />
      <path d="M18.5 18.5a9 9 0 0 0 0-13" />
    </svg>
  ),
  Clients: (p: P) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="6" r="2.5" />
      <circle cx="5" cy="17" r="2.5" />
      <circle cx="19" cy="17" r="2.5" />
      <path d="M12 8.5v3M7 15.5l3.5-3M17 15.5l-3.5-3" />
    </svg>
  ),
  Key: (p: P) => (
    <svg {...base} {...p}>
      <circle cx="8.5" cy="14.5" r="3.5" />
      <path d="M11 12l8-8" />
      <path d="M15 4h4v4" />
      <path d="M15 8l2 2" />
    </svg>
  ),
  Users: (p: P) => (
    <svg {...base} {...p}>
      <circle cx="9" cy="9" r="3.2" />
      <path d="M3 19c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <circle cx="17" cy="7.5" r="2.5" />
      <path d="M16 13.5c2.6 0.4 4.5 2.6 4.5 5.3" />
    </svg>
  ),
  SignOut: (p: P) => (
    <svg {...base} {...p}>
      <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
      <path d="M10 8l-4 4 4 4" />
      <path d="M6 12h12" />
    </svg>
  ),
  Spark: (p: P) => (
    <svg {...base} {...p}>
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  Activity: (p: P) => (
    <svg {...base} {...p}>
      <path d="M3 12h4l3-7 4 14 3-7h4" />
    </svg>
  ),
  Compass: (p: P) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M14.5 9.5l-1.2 4.3-4.3 1.2 1.2-4.3 4.3-1.2z" />
    </svg>
  ),
  Plus: (p: P) => (
    <svg {...base} strokeWidth={1.8} {...p}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  Search: (p: P) => (
    <svg {...base} {...p}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4 4" />
    </svg>
  ),
  Arrow: (p: P) => (
    <svg {...base} {...p}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  Back: (p: P) => (
    <svg {...base} {...p}>
      <path d="M19 12H5M11 6l-6 6 6 6" />
    </svg>
  ),
  Copy: (p: P) => (
    <svg {...base} {...p}>
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
    </svg>
  ),
  Key2: (p: P) => (
    <svg {...base} {...p}>
      <circle cx="8.5" cy="14.5" r="3.5" />
      <path d="M11 12l8-8" />
      <path d="M15 4h4v4" />
      <path d="M15 8l2 2" />
    </svg>
  ),
  Check: (p: P) => (
    <svg {...base} {...p}>
      <path d="M5 12l4 4 10-10" />
    </svg>
  ),
  X: (p: P) => (
    <svg {...base} {...p}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  ),
  Bot: (p: P) => (
    <svg {...base} {...p}>
      <rect x="4" y="7" width="16" height="12" rx="3" />
      <path d="M12 4v3" />
      <circle cx="9" cy="13" r="0.6" fill="currentColor" />
      <circle cx="15" cy="13" r="0.6" fill="currentColor" />
      <path d="M9 17h6" />
    </svg>
  ),
  Send: (p: P) => (
    <svg {...base} {...p}>
      <path d="M4 12l16-8-5 16-3-7-8-1z" />
    </svg>
  ),
  Edit: (p: P) => (
    <svg {...base} {...p}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  ),
  Trash: (p: P) => (
    <svg {...base} {...p}>
      <path d="M4 7h16" />
      <path d="M10 11v6M14 11v6" />
      <path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    </svg>
  ),
};
